




























































































































































































import { ColorsList, formatDate, formattedDate, getDateFormattedAsMoment, ID, PRIVILEGE_KEYS } from '../../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import Button from '../../../core/components/Button.vue';
import { NotificationStoreHelper } from '../../../core/mixins';
import Loading from 'vue-loading-overlay';
import { InsuranceServices } from '../../../insurance/api/InsuranceServices';


@Component({
    components: {
        Loading,
        Button
    }
})
export default class FarmingActions extends Mixins(NotificationStoreHelper) {
    @Prop({default: null}) harvestId: number;
    @Prop({default: false}) visible: boolean;
    @Prop({default: false}) isSowing: boolean;
    @Prop({default: false}) isCarrier: boolean;
    @Prop({default: false}) loadingRanchs: boolean;
    @Prop({default: false}) isRecalculating: boolean;
    @Prop({default: false}) existSowingDetail: boolean;
    @Prop({default: false}) visibilityUnirChacras: boolean;
    @Prop({default: false}) canAddRanchs: boolean;
    @Prop({default: false}) pendingGeofences: boolean;
    @Prop({default: false}) pendingDownloadProgress: boolean;
    @Prop({default: false}) existHarvestedPolygons: boolean;
    @Prop({default(){return []}}) ranchIds: Array<ID>;
    generateSatelliteImagesText: string = 'Generar imágenes satelitales';
    @Prop({default: ''}) sowingId: string;
    @Prop({default(){return []}}) selectedRanchs: any[];
    @Prop({default(){return []}}) itemsDetail: any[];
    generatingSatelliteImages: boolean = false;
    purpleColor: string = ColorsList.light_purple;
    yellowColor: string = ColorsList.yellow;
    joinRanchsColor: string = ColorsList.light_brown;


    @Emit()
    visibilityModalGetNamesFromGeojson(value: boolean){}

    @Emit()
    clickBtnAssignCropType(){}

    @Emit()
    clickBtnGenerateGeofences(){}

    @Emit()
    downloadGeoJson(){}

    @Emit()
    visibilityModalJoinRanchs(value: boolean){}

    @Emit()
    discardRanchs(){}

    @Emit()
    downloadProgress(){}

    @Emit()
    visibilityModalNewHarvest(value: boolean){}

    @Emit()
    closeModal(){}

    @Emit()
    clickReprocessPeriods(){}

    @Emit()
    clickReprocessVehicles(){}

    @Emit()
    classifyRanchs(){}

    @Emit()
    clickShowReprocessData(){}

    generateSatelliteImages(){
        this.generatingSatelliteImages = true;
        if(this.harvestId){
            InsuranceServices.generateSatelliteImagesByHarvest(Number(this.harvestId))
                .then(res => {
                    this.$_successLoadingDialog({
                        response: res,
                        alternative_msg: 'Se enviaron a generar las imágenes satelitales'
                    });
                    this.generatingSatelliteImages = false;
                })
                .catch(err => {
                    this.generatingSatelliteImages = false;
                    this.$_catchLoadingDialog({
                        response: err.response.data || {},
                        alternative_msg: 'No se pudo enviar a generar las imágenes'
                    });
                });
        }
        
    }

    @Emit()
    showPolicyModal(){
        this.closeModal();
    }
}
